import React, { Component } from 'react';
import config from 'react-global-configuration';
import CalendarDayTeam from './CalendarDayTeam';

class CalendarDay extends Component {


  render() {
    return (
<tr>
  {this.props.semana.map(function(dia, linha) {
    if (dia.day) {
      return (
        <td>
          <p className="text-center calendario-dia"><strong>{dia.day}</strong></p>
          <div className="calendario-cont">
            <CalendarDayTeam turmas={dia.teams} />
          </div>
        </td>
      );
    } else {
      return (
        <td></td>
      );      
    }
  })}
</tr>             
    );
  }
}

export default CalendarDay;



// WEBPACK FOOTER //
// ./src/Components/Calendar/Elements/CalendarDay.js